import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { MdCancel } from "react-icons/md";

export const Container = styled.div`
  padding: 0 10% 10%;
`;
export const Step = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 54px;
  margin-right: -10px;
`;
export const Gap = styled.div`
  margin: 0.25%;
`;
export const YellowText = styled(Link)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: -0.025em;
  text-transform: uppercase;
  color: #ffce26;
  text-decoration: none;
`;
export const SmallText = styled(Link)`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0.04em;
  color: #575757;
  text-decoration: none;
`;
export const Title = styled.div`
  font-weight: 900;
  font-size: 30px;
  color: #575757;
`;
export const TitleDescription = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #a6a6a6;
`;
export const ConfirmButton = styled.button`
  padding: 8px 30px;
  background: #dbdbdb;
  border-radius: 8px;
  color: white;
  font-size: 10px;
  border-color: #dbdbdb;
  font-style: normal;
  font-weight: normal;
  border: 0px;
`;
export const ChapterReactButton = styled.button`
  padding: 8px 30px;
  background: #ffce26;
  border-radius: 8px;
  color: #605a47;
  font-size: 10px;
  border-color: #ffce26;
  font-style: normal;
  font-weight: normal;
  border: 0px;
  margin-right: 10px;
`;
export const Card = styled.div``;
export const Content = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: start;
  margin-top: 10px;
`;
export const LeftTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #575757;
`;
export const LeftContent = styled.a`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #575757;
  margin: 5px 0px;
  cursor: pointer;
  text-decoration: none;
  display: block;
  &:hover {
    padding: 8px 16px;
    display: flex;
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin: 10px 65px 5px -15px;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    color: initial;
  }
`;
export const LeftCard = styled(Link)``;
export const TopicTitle = styled.div`
  padding-top: 12px;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 35px;
  color: #575757;
`;
export const ExpandCard = styled.div`
  padding: 20px 23px 20px 53px;
  margin: 0 0 20px 0;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  transition: height 4s;
  overflow: hidden;
  &.hide {
    height: 0;
    padding: 0;
    border: initial;
    box-shadow: initial;
  }
`;
// visible
export const TopicDescription = styled.div`
  padding-bottom: 12px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  // line-height: 18px;
  color: #575757;
  white-space: pre-wrap;
`;
export const RightTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #767676;
  margin: 25px 15px;
`;
export const RightDescription = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: #575757;
  margin-left: 15px;
`;
export const RightDescription1 = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 18px;
  color: #1976d2;
  margin-left: 15px;
`;
export const AddressBar = styled.div`
  padding: 8px 10px;
  display: flex;
  border: 0.5px solid #c8c5c5;
  box-sizing: border-box;
  border-radius: 10px;
`;
export const HorizontalLeft = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
`;
export const HorizontalStart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;
export const LeftContainer = styled.div`
  width: 25%;
  margin-top: 15px;
`;
export const RightContainer = styled.div`
  flex: 1;
  margin-top: 15px;
`;
export const Assignment = styled.div`
  padding: 5px 15px;
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: space-between;
  background: #f7f5f5;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
  border-radius: 3px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 30px;
  margin-left: 15px;
`;
export const AssignmentList = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: space-between;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
  border-radius: 3px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 30px;
  margin-left: 15px;
`;
export const Member = styled.div`
  flex: 1;
`;
export const Duty = styled.div`
  flex: 4;
`;
export const Deadline = styled.div`
  flex: 4;
`;
export const Done = styled.div`
  flex: 1;
`;
export const ButtonList = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: -10px;
`;
export const DocIframe = styled.iframe`
  width: 100%;
  height: 600px;
  border: initial;
`;
export const DocButton = styled.button`
  padding: 13px 26px;
  background-color: white;
  margin-left: 15px;
  border: 1px solid #505050;
  color: #505050;
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
  }
`;
export const IconContainer = styled.div`
  cursor: pointer;
`;
export const AddButton = styled.span`
  cursor: pointer;
  height: 50px;
  width: 50px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  border-radius: 50%;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
`;
export const ButtonRow = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 5px;
`;

export const DeleteButton = styled(MdCancel)`
  cursor: pointer;
`;
